export const getVersionFromLang = (lang: string) => {
  switch (lang) {
    case "en_US":
    case "en_GB":
    case "en_ZA":
    case "fr_FR":
    case "sv_SE":
    case "sv_SV":
      return `${lang}_2.0.0`
    case "ar":
      return "ar_SA_1.0.0"
    default:
      return `${lang}_1.0.0`
  }
}
